import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from 'partnerhub';
import { Observable } from 'rxjs';
import { filter, map, pluck } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class VouchersService {

  public baseURL = environment.serverApiBaseUrl;
  constructor(
    private readonly http: HttpClient, 
    private readonly helperService: HelperService,
    private readonly datePipe: DatePipe
  ) {}

  private tableSortOrderLogic(sortOrder) {
    return sortOrder === 1 ? (sortOrder = true) : (sortOrder = false);
  }

  private tableSortLogic(sort) {
    return (sort = sort ? '&sort=' + sort : '');
  }

  private tableGlobalFilterLogic(globalFilter) {
    return (globalFilter = globalFilter ? '&globalFilter=' + globalFilter : '');
  }

  private tableFilterLogic(myFilters) {
    if (myFilters) {
      let filters = '';
      let filterFields = Object.keys(myFilters);
      filterFields.map((filterField, i) => {
        const filterValue = myFilters[filterField]?.value
          ? myFilters[filterField].value
          : typeof myFilters[filterField] == 'string'
          ? myFilters[filterField]
          : '';

        if (filterField != 'global' && filterValue) {
          if (i == 0) {
            filters = '&' + filters + filterField + '=' + filterValue;
          } else {
            filters = filters + '&' + filterField + '=' + filterValue;
          }
        }
      });
      return (myFilters = filters);
    } else {
      return (myFilters = '');
    }
  }

  public getVoucherDetails(voucherId): any {
    const url = `/${this.baseURL}/voucher/${voucherId}`;
    return this.http.get(url);
  }

  public disableVoucher(voucherId): any {
    const url = `/${this.baseURL}/voucher/${voucherId}/disable`;
    return this.http.post(url, null);
  }

  public getVouchersCount = (globalFilter?: any, myFilters?: any): Observable<number> => {
    const url = `/${this.baseURL}/voucher/count?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  };

  public getVouchers = (
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<any[]> => {
    const url =
      `/${this.baseURL}/voucher?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<any[]>(url);
  };

  public getVoucherCategories(){
    const url = `/${this.baseURL}/voucher/voucher-types`;
    return this.http.get(url);
  }

  public createVoucher(formValues){
    const url = `/${this.baseURL}/voucher`;
    let data = Object.assign({}, formValues);
    console.log("DEBUG (2):", formValues, data);
    let eligibility = [];
    if (data.eligibility && Array.isArray(data.eligibility)){
      data.eligibility.map(valEligibility => {
        eligibility.push(valEligibility.id);
      })
    }
    data.eligibility = eligibility;
    data.voucherStartDate = this.datePipe.transform(formValues.voucherStartDate, "dd/MM/yyyy");
    data.voucherEndDate = this.datePipe.transform(formValues.voucherEndDate, "dd/MM/yyyy");
    data.listProductId = data.voucherType == "LIST_PRODUCTS" 
      ? (data.productIdArray || []).map(item => item.id ?? item)
      : (data.productId ? [data.productId.id ?? data.productId] : []);
      
    switch(data.voucherType){
      case "SINGLE_PRODUCT":
        data.productId = data.offerId?.id;
        delete data.category;
        delete data.categoryCount;
        delete data.partnerId;
        delete data.offerId;
        break;
      case "LIST_PRODUCTS":
        data.productId = data.offerId?.id;
        delete data.category;
        delete data.categoryCount;
        delete data.partnerId;
        delete data.offerId;
        break;
      case "ALL_PRODUCTS":
        delete data.category;
        delete data.categoryCount;
        delete data.partnerId;
        delete data.productIdArray;
        delete data.productId;
        delete data.offerId;
        break;
      case "CATEGORY":
        delete data.categoryCount;
        delete data.partnerId;
        delete data.productId;
        delete data.offerId;
        break;
      case "CATEGORY_COUNTER":
        delete data.partnerId;
        delete data.productId;
        delete data.offerId;
        break;
    }
    console.log(data);
    return this.http.post(url, data);
  }
}
